module.exports = __webpack_public_path__ + "static/6-08103ca1df9de55c76600a5fb21fd08c.jpg";